import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-steps-indicator"
}
const _hoisted_2 = { class: "gfu-steps-indicator__progressbar" }
const _hoisted_3 = ["href", "data-qa"]
const _hoisted_4 = ["onClick", "data-qa"]
const _hoisted_5 = { key: 3 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return ($props.steps.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(['gfu-steps-indicator__container', `gfu-steps-indicator__container-${$props.steps.length}`]),
          "data-qa": "steps-indicator"
        }, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.steps, (step, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(['gfu-steps-indicator__step', { 'gfu-steps-indicator__step--active': step.isActive }])
              }, [
                (!$props.isInAdminMode && step.url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: step.url,
                      class: "gfu-steps-indicator__link",
                      "data-qa": `steps-indicator-step:${step.text}`
                    }, [
                      _createElementVNode("span", null, _toDisplayString(step.text), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_3))
                  : ($props.isInAdminMode && step.url)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: step.url,
                        class: "gfu-steps-indicator__link",
                        "data-qa": `steps-indicator-step:${step.text}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(step.text), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "data-qa"]))
                    : (typeof(step.onClick) === 'function')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: "",
                          class: "gfu-steps-indicator__link",
                          onClick: _withModifiers($event => (step.onClick(index)), ["prevent"]),
                          "data-qa": `steps-indicator-step:${step.text}`
                        }, [
                          _createElementVNode("span", null, _toDisplayString(step.text), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_4))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(step.text), 1 /* TEXT */))
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */)
      ]))
    : _createCommentVNode("v-if", true)
}